import React from 'react';

import { useSelector } from 'react-redux';

import NatLoc from 'natloc-component';

import {
  TextField,
} from '@mui/material';

import { UuidButton } from '../Utils/UuidButton';
import { CustomSelect } from '../CustomSelect/CustomSelect';
import { CategoryOptions } from '../CategoryOptions/CategoryOptions';

import translation from '../../assets/translation.json';
import appStyle from './appStyle';
import { CustomInput } from '../CustomInput/CustomInput';

export const App = () => {
  const classes = appStyle();
  const { externalParams } = useSelector((store: any) => store.appReducer);


  const handleEvent = (data: any) => {
    console.log(data);
  };

  return (
    <div
      className={classes.root}
      /* style={{
        display: 'flex',
        justifyContent: 'flex-end',
        flexDirection: 'column-reverse',
        padding: '20px',
        overflow: 'none',
      }} */>
      <div
        className={classes.widget}
      /*  style={{
         display: 'flex',
         alignItems: 'center',
         justifyContent: 'center',
         height: '20vh',
         flexDirection: 'column',

       }} */
      >

        <CategoryOptions defaultValue={externalParams.category} enabled={externalParams.enabledCategory} />
        <NatLoc
          translations={translation}
          sessionId={externalParams.sessionId}
          step={externalParams.step}
          provider={externalParams.provider}
          category={externalParams.category}
          finishEvent={handleEvent}
          cups={externalParams.defaultCups}
          postalCode={externalParams.postalCode}/>

      </div>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <UuidButton />
        <div style={{ display: 'flex', height: '70px', paddingBottom: '20px' }}>
          <CustomInput />
        </div>
        <div style={{ display: 'flex', height: '100px', paddingBottom: '20px' }}>
          <CustomSelect id='step' defaultValue={3} options={[0, 2, 3, 5]} />
          <CustomSelect id='provider' defaultValue={'iberia'} options={['iberia', 'newco']} />
          <CustomSelect id='postalCode' defaultValue={'hide'} options={['hide', 'show']} />

        </div>

      </div>

    </div>
  );
};
